import { render } from "./paper_export_detail.vue?vue&type=template&id=6911b87d"
import script from "./paper_export_detail.vue?vue&type=script&lang=js"
export * from "./paper_export_detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__